/**
 * a component that closes the dialog when a link inside it is clicked
 */import React, { useEffect } from "react";
export var LinkClickHandler = function LinkClickHandler(param) {
  var onLinkClick = param.onLinkClick,
    children = param.children;
  useEffect(function () {
    var handleClick = function handleClick(e) {
      if (e.target.closest("a")) {
        onLinkClick();
      }
    };
    document.addEventListener("click", handleClick);
    return function () {
      return document.removeEventListener("click", handleClick);
    };
  }, [onLinkClick]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
LinkClickHandler.displayName = "LinkClickHandler";